module.exports = __webpack_public_path__ + "img/icon1.bf2997da.png";